document.addEventListener("DOMContentLoaded", function () {
  const FAVORITES_KEY = "favorites";

  function getFavorites() {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
  }

  function saveFavorites(favs) {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favs));
  }

  function toggleFavorite(handle, button) {
    let favorites = getFavorites();
    const index = favorites.indexOf(handle);
    const isFavoritesPage =
      window.location.pathname.includes("/favorites") ||
      window.location.pathname.includes("/favorilerim");

    if (index >= 0) {
      favorites.splice(index, 1);
      button.querySelector(".favorite-icon").textContent = "🤍";

      if (isFavoritesPage) {
        const card = button.closest(".product-card");
        if (card) card.remove();

        if (getFavorites().length === 0) {
          const emptyText = document.getElementById("favorites-empty");
          if (emptyText) emptyText.style.display = "block";
        }
      }
    } else {
      favorites.push(handle);
      button.querySelector(".favorite-icon").textContent = "❤️";
    }

    saveFavorites(favorites);
  }

  // 🔁 Yeni butonlar için event delegation
  document.body.addEventListener("click", function (e) {
    const button = e.target.closest(".favorite-button");
    if (!button) return;

    const handle = button.dataset.productHandle;
    toggleFavorite(handle, button);
  });

  // Sayfa ilk yüklenirken ikonları güncelle
  function updateAllButtons() {
    const favorites = getFavorites();
    document.querySelectorAll(".favorite-button").forEach((button) => {
      const handle = button.dataset.productHandle;
      if (favorites.includes(handle)) {
        button.querySelector(".favorite-icon").textContent = "❤️";
      } else {
        button.querySelector(".favorite-icon").textContent = "🤍";
      }
    });
  }

  updateAllButtons();
});
